import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import Dot from 'components/Dot';
import Message from 'components/Message';
import { TooltipContent, TooltipToggle } from 'components/Tooltip';
import When from 'components/When';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import { BOOKABLE_STATUS_ICON_TYPES } from 'components/ClassesList/ClassesList.helpers';

import './PricingStatusBadge.scss';

const { block, element } = bem('pricing-status-badge');

const PricingStatusBadge = ({ alignedRight, iconType, messageKey, messages, tooltipMessageKey, tooltipName }) => {
  const hasTooltip = Boolean(tooltipMessageKey);

  function renderIcon() {
    switch (iconType) {
      case BOOKABLE_STATUS_ICON_TYPES.GREY_DOT:
        return <Dot className={element('icon', { 'grey-dot': true })} color={Dot.COLORS.LIGHT} />;

      case BOOKABLE_STATUS_ICON_TYPES.GREEN_DOT:
        return <Dot className={element('icon', { 'green-dot': true })} color={Dot.COLORS.GREEN} />;

      case BOOKABLE_STATUS_ICON_TYPES.PENDING: {
        const icon = <Isvg src={ICONS.clock} className={element('icon', { pending: true })} aria-hidden="true" />;

        return hasTooltip ? <TooltipToggle name={tooltipName}>{icon}</TooltipToggle> : icon;
      }

      case BOOKABLE_STATUS_ICON_TYPES.ACTION_ALERT: {
        const icon = (
          <Isvg src={ICONS.alertTriangle} className={element('icon', { 'action-alert': true })} aria-hidden="true" />
        );

        return hasTooltip ? <TooltipToggle name={tooltipName}>{icon}</TooltipToggle> : icon;
      }

      default:
        return null;
    }
  }

  return (
    <span className={block({ 'right-aligned': alignedRight })}>
      {renderIcon()}
      <Message className={element('label')} message={messages[messageKey]} />
      <When predicate={hasTooltip}>
        <TooltipContent name={tooltipName}>
          <Message message={messages[tooltipMessageKey]} />
        </TooltipContent>
      </When>
    </span>
  );
};

PricingStatusBadge.propTypes = {
  alignedRight: PropTypes.bool,
  iconType: PropTypes.oneOf(Object.values(BOOKABLE_STATUS_ICON_TYPES)),
  messageKey: PropTypes.string,
  messages: PropTypes.shape({}),
  tooltipMessageKey: PropTypes.string,
  tooltipName: PropTypes.string.isRequired,
};

export default PricingStatusBadge;
